import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3609f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  class: "content",
  style: {"scroll-behavior":"smooth"}
}
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_4 = { style: {"font-size":"18px"} }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = { class: "col-8 mt-2" }
const _hoisted_8 = {
  key: 1,
  class: "col-4 mt-2 clear-coupons-link"
}
const _hoisted_9 = {
  key: 0,
  class: "alert justify-content-between"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "18",
  viewBox: "0 0 23 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.5 0L22.3253 17.25H0.674683L11.5 0Z",
    fill: "#D98B17"
  })
], -1))
const _hoisted_11 = { class: "px-2" }
const _hoisted_12 = {
  key: 1,
  class: "alert"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-12 circle" }, null, -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  class: "d-flex",
  style: {"gap":"10px"}
}
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "order-block" }
const _hoisted_18 = { class: "benefit col-6" }
const _hoisted_19 = { class: "order-info col-6" }
const _hoisted_20 = { class: "coupon-header p-3 rounded-top" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "coupon" }
const _hoisted_23 = { class: "p-3 d-flex flex-wrap justify-content-between" }
const _hoisted_24 = { class: "col-12 d-flex" }
const _hoisted_25 = { style: {"white-space":"nowrap"} }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_27 = { class: "dotted-text" }
const _hoisted_28 = { class: "col-12 d-flex" }
const _hoisted_29 = { style: {"white-space":"nowrap"} }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_31 = { class: "col-12 d-flex" }
const _hoisted_32 = { style: {"white-space":"nowrap"} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_34 = { class: "dotted-text" }
const _hoisted_35 = { class: "col-6 d-flex" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_37 = {
  key: 0,
  class: "col-6 d-flex"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_39 = {
  key: 1,
  class: "col-6 d-flex"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_41 = {
  key: 2,
  class: "col-6 d-flex"
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode(":  ")
const _hoisted_43 = {
  key: 3,
  class: "col-12"
}
const _hoisted_44 = { class: "red" }
const _hoisted_45 = { class: "red" }
const _hoisted_46 = {
  class: "d-flex p-3 justify-content-between rounded-bottom",
  style: {"background":"#F5F5F5"}
}
const _hoisted_47 = { class: "d-flex gap-3" }
const _hoisted_48 = {
  key: 0,
  class: "col-7"
}
const _hoisted_49 = { class: "d-flex gap-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "d-flex gap-2" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "col-7"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "col-12" }, null, -1))
const _hoisted_57 = { class: "footer" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))
const _hoisted_59 = { class: "padding" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_62 = { class: "buttons d-flex justify-content-between" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "padding" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_67 = { class: "buttons d-flex justify-content-between" }
const _hoisted_68 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_BenefitInfo = _resolveComponent("BenefitInfo")!
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_OverlayModal = _resolveComponent("OverlayModal")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ViewHeader, {
          text: _ctx.club?.name
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('cashier.scan.number')), 1),
            _createVNode(_component_TextInput, {
              onKeyup: _withKeys(_ctx.search, ["enter"]),
              class: "col-7",
              clearable: true,
              modelValue: _ctx.orderNumber,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderNumber) = $event))
            }, null, 8, ["onKeyup", "modelValue"]),
            _createElementVNode("button", {
              style: {"font-size":"18px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
              class: "btn-search px-5"
            }, _toDisplayString(_ctx.$t('cashier.scan.search')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isMoreCoupons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searches, (searched, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "text-muted searched-value"
                    }, _toDisplayString(searched), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('cashier.more-coupons')), 1),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "toggle custom_checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isMoreCoupons) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.isMoreCoupons]
              ])
            ]),
            (_ctx.isMoreCoupons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "link",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearAllCoupons && _ctx.clearAllCoupons(...args)))
                  }, _toDisplayString(_ctx.$t('cashier.clear-all-coupons')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.orderFound != null && _ctx.orderFound == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('cashier.scan.order-not-found')), 1)
                ]),
                _createElementVNode("button", {
                  class: "btn-green",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.manualOrder && _ctx.manualOrder(...args))),
                  style: {"height":"41px"}
                }, _toDisplayString(_ctx.$t('cashier.scan.create-manual-order')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('cashier.scan.order-found')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('cashier.response.title', { couponSystem: 'Multipass' })), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.cashier-products')), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.budgets, (budget, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.benefitList, (benefit) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: benefit.benefitId + budget.cardCode
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_BenefitInfo, { benefit: benefit }, null, 8, ["benefit"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefitCoupons(benefit, budget.cardCode), (products, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products, (product) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "section",
                                    key: product.id
                                  }, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass({'link red': product.id == 0, 'dotted-text': product.id != 0}),
                                        onClick: ($event: any) => (_ctx.onProductNameClick(product))
                                      }, _toDisplayString(product.id == 0 ? _ctx.$t('cashier.scan.product.select') : product.name), 11, _hoisted_21)
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('cashier.response.coupon-name')), 1),
                                          _hoisted_26,
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(product.priceLine.coupon?.couponName), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('cashier.response.expiration-date')), 1),
                                          _hoisted_30,
                                          _createElementVNode("div", null, _toDisplayString(_ctx.formatDateString(product.priceLine.coupon?.validDateTo)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('cashier.response.customer-name')), 1),
                                          _hoisted_33,
                                          _createElementVNode("div", _hoisted_34, _toDisplayString(product.id != 0 ? _ctx.getCouponCustomerTypesByProductId(product.id, product.priceLine.coupon?.id ?? 0)?.map(ct => ct.customerTypeName).join(", ") : '...'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.qty')), 1),
                                          _hoisted_36,
                                          _createElementVNode("div", null, _toDisplayString(product.priceLine.quantity), 1)
                                        ]),
                                        (product.priceLine.coupon?.discountPercent)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.discount')), 1),
                                              _hoisted_38,
                                              _createElementVNode("div", null, [
                                                _createElementVNode("span", null, _toDisplayString(product.priceLine.coupon.discountPercent) + " %", 1)
                                              ])
                                            ]))
                                          : (product.priceLine.coupon?.discountAmount)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.discount')), 1),
                                                _hoisted_40,
                                                _createElementVNode("div", null, _toDisplayString(product.priceLine.coupon.discountAmount) + " " + _toDisplayString(product.priceLine.coupon.currencySymbol), 1)
                                              ]))
                                            : (product.priceLine.coupon?.ticketFixedUnitPrice)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.response.discount')), 1),
                                                  _hoisted_42,
                                                  _createElementVNode("div", null, _toDisplayString(product.priceLine.coupon.ticketFixedUnitPrice), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                        (product.priceLine.coupon?.ticketLimitation)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('cashier.coupon.availability-error')), 1),
                                              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('cashier.coupon.max-discount', {
                                                            amount: product.priceLine.coupon?.ticketLimitation, currency:
                                                            product.priceLine.coupon?.currencySymbol
                                                        })), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        (product.date && product.slotStartTime && product.id != 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              _createElementVNode("div", _hoisted_49, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.coupon.slot.date')) + ":", 1),
                                                _createElementVNode("div", {
                                                  class: "link",
                                                  onClick: ($event: any) => (_ctx.onSelectDate(product.id, benefit.benefitId, product.slotId, product.date, budget, product.priceLine.coupon?.priceTypeIds[0]))
                                                }, _toDisplayString(_ctx.formatDateString(product.date)), 9, _hoisted_50)
                                              ]),
                                              _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.coupon.slot.time')) + ":", 1),
                                                _createElementVNode("div", {
                                                  class: "link",
                                                  onClick: ($event: any) => (_ctx.onSelectDate(product.id, benefit.benefitId, product.slotId, product.date, budget, product.priceLine.coupon?.priceTypeIds[0]))
                                                }, _toDisplayString(product.slotStartTime ?? ""), 9, _hoisted_52)
                                              ])
                                            ]))
                                          : (product.id != 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("div", {
                                                    class: "link red",
                                                    style: {"white-space":"nowrap"},
                                                    onClick: ($event: any) => (_ctx.onSelectDate(product.id, benefit.benefitId,product.slotId,product.date, budget, product.priceLine.coupon?.priceTypeIds[0]))
                                                  }, _toDisplayString(_ctx.$t('cashier.select-date')), 9, _hoisted_54)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("button", {
                                        disabled: !products.some(x => x.priceLine.quantity ?? 0 > 0) || _ctx.isExpired(benefit) || !products.every(x => x.date && x.slotStartTime) || product.id == 0,
                                        onClick: ($event: any) => (_ctx.addProductsToOrder(product)),
                                        class: "px-5 btn-green"
                                      }, _toDisplayString(_ctx.$t('cashier.coupon.add')), 9, _hoisted_55)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ]),
                        _hoisted_56
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-back",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
          }, [
            _hoisted_58,
            _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.back")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_OverlayModal, {
      "is-open": _ctx.isOpenCustomerTypesModal,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isOpenCustomerTypesModal = false)),
      "modal-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-content", { 'expand': _ctx.isOpenCustomerTypesModal }])
            }, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("form", {
                  onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_60, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCouponCustomerTypesByProductId(_ctx.currentOrderProduct?.id ?? 0, _ctx.currentOrderProduct?.priceLine.coupon?.id ?? 0), (customerType, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-12 mb-3"
                      }, [
                        _createVNode(_component_RadioInput, {
                          name: "customerTypeProduct",
                          value: customerType.productCustomerTypeId,
                          modelValue: _ctx.currentCustomerTypeId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentCustomerTypeId) = $event)),
                          onChange: ($event: any) => (index === 0 && (_ctx.currentCustomerTypeId = customerType.productCustomerTypeId)),
                          class: "radio-select"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(customerType.customerTypeName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "modelValue", "onChange"])
                      ]))
                    }), 128))
                  ]),
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      disabled: !_ctx.currentCustomerTypeId,
                      type: "submit",
                      class: "p-ripple button-custom submit-btn"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('cashier.coupon.add')), 1)
                    ], 8, _hoisted_63)), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                      type: "button",
                      class: "p-ripple button-custom cancel-btn"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
                    ])), [
                      [_directive_ripple]
                    ])
                  ])
                ], 32)
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_OverlayModal, {
      "is-open": _ctx.isOpenProductsModal,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isOpenProductsModal = false)),
      "modal-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-content", { 'expand': _ctx.isOpenProductsModal }])
            }, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("form", {
                  onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.chooseProduct && _ctx.chooseProduct(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductsByCoupon(_ctx.currentOrderProduct?.priceLine.coupon), (product, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-12 mb-3"
                      }, [
                        _createVNode(_component_RadioInput, {
                          name: "customerTypeProduct",
                          value: product.id,
                          modelValue: _ctx.currentProductId,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentProductId) = $event)),
                          onChange: ($event: any) => (index === 0 && (_ctx.currentProductId = product.id)),
                          class: "radio-select"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(product.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "modelValue", "onChange"])
                      ]))
                    }), 128))
                  ]),
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      disabled: !_ctx.currentProductId,
                      type: "submit",
                      class: "p-ripple button-custom submit-btn"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('productsFilter.choose')), 1)
                    ], 8, _hoisted_68)), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      onClick: _cache[11] || (_cache[11] = () => {_ctx.currentProductId = undefined; _ctx.currentOrderProduct = null; _ctx.isOpenProductsModal = false}),
                      type: "button",
                      class: "p-ripple button-custom cancel-btn"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
                    ])), [
                      [_directive_ripple]
                    ])
                  ])
                ], 32)
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}